import { render, staticRenderFns } from "./benevolenceDetails.vue?vue&type=template&id=499e595c&scoped=true"
import script from "./benevolenceDetails.vue?vue&type=script&lang=js"
export * from "./benevolenceDetails.vue?vue&type=script&lang=js"
import style0 from "./benevolenceDetails.vue?vue&type=style&index=0&id=499e595c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499e595c",
  null
  
)

export default component.exports